module.exports = __webpack_public_path__ + "img/features-plataforma.04e2820b.png";